import {
  Button, Card, Select, Space, Table, Typography,
} from 'antd';
import rentalApi from 'api/rentalApi';
import ToastHelper from 'general/helpers/ToastHelper';
import useRouter from 'hooks/useRouter';
import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  formatDateTime, getRentalErrorMessage, PARTNER_STATUS_OPTIONS, PartnerStatusTag,
} from '../../rentalConstants';

const { Text, Title } = Typography;

function RentalPartnerListScreen() {
  const router = useRouter();
  const [status, setStatus] = useState('PENDING');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [partners, setPartners] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await rentalApi.getPartners({ status: status || undefined, page, pageSize });
      setPartners(response?.partners || []);
      setTotal(response?.total || 0);
    } catch (error) {
      setPartners([]);
      setTotal(0);
      ToastHelper.showError(getRentalErrorMessage(error));
    } finally {
      setLoading(false);
    }
  }, [status, page, pageSize]);

  useEffect(() => { load(); }, [load]);

  const goToDetail = (rentalPartnerId) => router.navigate(`${rentalPartnerId}`);

  const columns = useMemo(() => [
    { title: 'Mã hồ sơ', dataIndex: 'rentalPartnerId', width: 100, render: (value) => <Text strong>#{value}</Text> },
    {
      title: 'Đối tác',
      key: 'partner',
      render: (_, row) => (
        <div>
          <div><Text strong>{row.contactName || row?.user?.fullname || 'Chưa có tên'}</Text></div>
          <Text type="secondary">{row.contactPhone || row?.user?.phone || `User #${row.userId}`}</Text>
        </div>
      ),
    },
    { title: 'Địa điểm giao nhận', dataIndex: 'handoverAddress', ellipsis: true },
    { title: 'Trạng thái', dataIndex: 'status', width: 140, render: (value) => <PartnerStatusTag status={value} /> },
    { title: 'Cập nhật', dataIndex: 'updatedAt', width: 170, render: formatDateTime },
    {
      title: '', key: 'action', width: 110,
      render: (_, row) => <Button type="link" onClick={() => goToDetail(row.rentalPartnerId)}>Xem hồ sơ</Button>,
    },
  ], []);

  return (
    <div className="container-fluid px-4 my-4">
      <Card>
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
          <div>
            <Title level={4} className="mb-0">Đối tác cho thuê xe</Title>
            <Text type="secondary">Tổng {total} hồ sơ theo bộ lọc</Text>
          </div>
          <Button onClick={load} loading={loading}>Làm mới</Button>
        </div>
        <Space wrap className="mb-4">
          <Select
            value={status}
            options={PARTNER_STATUS_OPTIONS}
            style={{ width: 190 }}
            onChange={(value) => { setStatus(value); setPage(1); }}
          />
        </Space>
        <Table
          rowKey="rentalPartnerId"
          loading={loading}
          dataSource={partners}
          columns={columns}
          scroll={{ x: 900 }}
          locale={{ emptyText: 'Không có dữ liệu' }}
          pagination={{
            current: page,
            pageSize,
            total,
            showSizeChanger: true,
            onChange: (nextPage, nextPageSize) => { setPage(nextPage); setPageSize(nextPageSize); },
          }}
          onRow={(row) => ({ onDoubleClick: () => goToDetail(row.rentalPartnerId) })}
        />
      </Card>
    </div>
  );
}

export default RentalPartnerListScreen;
